// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3b-md","heart":"Footer_heart__1fA4l"};